import { CommonModule } from '@angular/common';
import { Component, AfterViewInit } from '@angular/core';
import { HomepageComponent } from '../homepage/homepage.component';
import { BatchComponent } from "../batch/batch.component";
@Component({
  selector: 'app-index',
  imports: [CommonModule, BatchComponent],
  templateUrl: './animation.component.html',
  styleUrls: ['./animation.component.css']
})
export class AnimationComponent implements AfterViewInit {
  showHome:boolean = false;
  particles = Array(20).fill(0);
  ngAfterViewInit(): void {
    const container = document.querySelector('.animation-container');
    setTimeout(() => {
      if (container) {
        container.classList.add('exit');
        setTimeout(() => {
          this.showHome = true;
        }, 1600);
      }
    }, 2000);
  }
}